"use client";

import { useCallback, useContext, useRef } from "react";
import { ChladniCanvas } from "./ChladniCanvas";
import { ChladniHoverContext } from "./ChladniHoverContainer";

export function ChladniHoverClient({
  children: placeholder,
  stroke,
  strokeWidth,
  strokeOpacity,
}: {
  children: React.ReactNode;
  stroke: string;
  strokeWidth: number;
  strokeOpacity: number;
}) {
  const context = useContext(ChladniHoverContext);
  if (!context) {
    throw new Error("ChladniHoverClient must be used within an ChladniHoverContainer");
  }

  const initial = useRef(true);
  const placeholderRef = useRef<HTMLDivElement>(null);

  const onDraw = useCallback(() => {
    if (initial.current) {
      initial.current = false;
      placeholderRef.current?.style.setProperty("visibility", "hidden");
    }
  }, []);

  const props =
    context.mode === "sources"
      ? {
          mode: context.mode,
          symmetry: context.symmetry,
          ...context.motionValues,
        }
      : {
          mode: context.mode,
          anchor: context.anchor,
          symmetry: context.symmetry,
          ...context.motionValues,
        };

  return (
    <>
      <ChladniCanvas
        {...props}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeOpacity={strokeOpacity}
        onDraw={onDraw}
      />
      <div ref={placeholderRef}>{placeholder}</div>
    </>
  );
}
